import { render } from "./PostsByAuthorPage.vue?vue&type=template&id=7423acf6&ts=true"
import script from "./PostsByAuthorPage.vue?vue&type=script&lang=ts"
export * from "./PostsByAuthorPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__